import { CREATE, LOAD, REMOVE, UPDATE } from 'model/automatchTemplate';
import { create, load, remove, update } from 'sdk/automatchTemplate';
import { takeEvery } from 'redux-saga/effects';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    CREATE.ACTION,
    callAction({
      api: create,
      dataName: ORM,
      formatSuccessMessage: ({ response }) =>
        `Template "${response.name}" was created`,
      type: CREATE,
    })
  );

  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(
    REMOVE.ACTION,
    callAction({
      api: remove,
      dataName: ORM,
      formatSuccessMessage: ({ response }) =>
        `Template "${response.name}" was removed`,
      type: REMOVE,
    })
  );

  yield takeEvery(
    UPDATE.ACTION,
    callAction({
      api: update,
      dataName: ORM,
      formatSuccessMessage: ({ response }) =>
        `Template "${response.name}" was updated`,
      type: UPDATE,
    })
  );
}
